import React, { Fragment, useState, useCallback } from "react";
import { Col, Card, CardBody } from "reactstrap";
import TabComponent from "./TabComponent";
import NavComponent from "./NavComponent";
import { useSelector } from "react-redux";

const LeftDetails = () => {
  const [activeTab, setActiveTab] = useState("2");
  const serviceDetails = useSelector((state) => state.services.serviceDetail);
  const [reload, setReload] = useState(false);

  const callback = useCallback((tab) => {
    setActiveTab(tab);
  }, []);

  return (
    <Fragment>
      <Col xl="12" className="box-col-12">
        <Card>
          <CardBody className="pb-0">
            {serviceDetails?.name && (
              <h6 className="mb-3">{serviceDetails.name}</h6>
            )}
            <NavComponent
              callbackActive={callback}
              activeTab={activeTab}
              reload={setReload}
            />
          </CardBody>
        </Card>
        <div className="mt-3">
          <TabComponent activeTab={activeTab} reload={reload} />
        </div>
      </Col>
    </Fragment>
  );
};

export default LeftDetails;
